import Vue from 'vue'
import { IAM } from '@rhitics/core'
import { Auth } from './Auth'
//@ts-ignore
window.Auth = Auth

interface Data {
  user: IAM.UserAggregate | null
  accessToken: string | null
}

export default Vue.extend({
  data(): Data {
    return {
      user: null,
      accessToken: null
    }
  },
  computed: {
    isAdmin(): boolean {
      return this.user ? this.allPolicies.some(policy => policy.name === 'rhitics_full_access') : false
    },
    isLogin(): boolean {
      return !!this.accessToken
    },
    allPolicies(): Array<IAM.Policy> {
      if (!this.user) return []
      const groupPolicies = this.user.groups!.map(g => (g.policies ? g.policies : [])).flat()
      const rolesPolicies = this.user.roles!.map(r => (r.policies ? r.policies : [])).flat()
      return this.user.policies!.concat(groupPolicies, rolesPolicies)
    }
  },

  created() {
    this.accessToken = this.getTokenFromCookie()
  },

  methods: {
    async fetchUserData(token?: string) {
      return await Auth.user(token)
    },
    async register(options: { name: string; email: string; password: string }) {
      return await Auth.register(options)
    },
    async login(email?: string, password?: string) {
      const res = await Auth.login(email, password)
      if (res) this.setToken(res.data.access_token)

      return res
    },
    async logout() {
      const res = await Auth.logout()
      this.setToken(null)

      return res
    },
    forget() {
      Auth.forget()
    },
    getTokenFromCookie() {
      return Auth.token()
    },
    generateBeam() {
      return Auth.generateBeam()
    },
    setToken(token: string | null) {
      this.accessToken = token

      return this
    },
    check() {
      return Auth.check()
    },
    setUser(user: IAM.UserAggregate) {
      this.$set(this, 'user', user)

      return this
    },
    setGroups(groups: Array<IAM.GroupAggregate>) {
      if (this.user) this.$set(this.user, 'groups', groups)

      return this
    },
    setRoles(roles: Array<IAM.RoleAggregate>) {
      if (this.user) this.$set(this.user, 'roles', roles)

      return this
    },
    setPolicies(policies: Array<IAM.Policy>) {
      if (this.user) this.$set(this.user, 'policies', policies)

      return this
    },
    can(policy: string) {
      return this.isAdmin || this.allPolicies.some(ability => ability.name === policy)
    },
    is(role: string) {
      return this.isAdmin || (this.user as IAM.UserAggregate).roles!.some(r => r.name === role)
    },
    in(group: string) {
      return this.isAdmin || (this.user as IAM.UserAggregate).groups!.some(g => g.name === group)
    },
    permission({ policies = [], roles = [], groups = [] }: { policies: string[]; roles: string[]; groups: string[] }) {
      policies = policies ?? []
      roles = roles ?? []
      groups = groups ?? []
      return (
        policies.every(policy => this.can(policy)) &&
        roles.every(role => this.is(role)) &&
        groups.every(group => this.in(group))
      )
    }
  }
})
